invHdApp.
  factory('Station', ['$http', function ($http) {
    return {
      all: function (data) {
        return $http.post('api/stations', data);
      },
      get: function (id) {
        return $http.get('api/station/' + id);
      },
      new: function (id) {
        return $http.get('api/new-station');
      },
      delete: function (id) {
        return $http.delete('api/delete-station/' + id);
      },
      save: function (data) {
        return $http.post('api/save-station', data);
      },
      update: function (data) {
        return $http.post('api/update-station', data);
      },
      getCityDistricts: function (data) {
        return $http.post('api/station-districs', data);
      },
      getNeighbourhood: function (data) {
        return $http.post('api/station-neighbourhood', data);
      }
    };
  }]);